<template>
  <div class="skin-green sidebar-mini">
    <div class="wrapper">    
      <va-navibar-orange></va-navibar-orange>  
      <va-slider-orange></va-slider-orange>
      <va-content-wrap style="background-color:#F6F6F6;"></va-content-wrap>
      <Modal></Modal>
    </div>
  </div>
</template>

<script>
import VANaviBarOrange from '../navigation/NaviBarOrange.vue'
import VASliderOrange from '../navigation/SliderOrange.vue'
import VAContentWrap from '../navigation/ContentWrap.vue'
import Modal from '../modal/Modal.vue'

export default {
  name: 'masterOrange',
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  components: {
    'va-navibar-orange': VANaviBarOrange,
    'va-slider-orange': VASliderOrange,
    'va-content-wrap': VAContentWrap,
    Modal
  }
}
</script>

<style type="text/CSS">

  .sidebar-mini.sidebar-collapse .content-wrapper
  {
    margin-top: 0px;
    margin-left: 65px !important;
  }

  .main-sidebar
  {
    display: block;
  }

  .div-view
  {
    position: absolute;
  }

  .div-display
  {
    display: block !important;
  }

  .div-none
  {
    display: none !important;
  }

  @media (min-width: 320px) {
    .sidebar-mini.sidebar-collapse .main-sidebar {
      -webkit-transform: translate(0, 0);
      -ms-transform: translate(0, 0);
      -o-transform: translate(0, 0);
      transform: translate(0, 0);
      width: 50px !important;
      z-index: 850;
      padding-top: 15px;   
      background: #FFFFFF;
      box-shadow: 0px 2px 4px rgba(76, 93, 112, 0.24), 0px 0px 1px rgba(76, 93, 112, 0.3);
      border-radius: 0px 6px 6px 0px;         
    }

    .sidebar-mini.sidebar-collapse .main-sidebar LI SPAN{
      display: none;
    }
  }

  @media screen and (max-width: 414px) {
    .sidebar-mini.sidebar-collapse .content-wrapper
    {      
      margin-left: 0px !important;
    }

    .box-header
    {
      padding-left: 25px !important;
    }

    .main-sidebar
    {
      display: none;
    } 
    
    .menu-ora
    {
      display: block !important;
    }

    .navbar-custom-menu
    {
      display: none !important;

      top: -10px;
    position: relative;

    }

    .nav-order
    {
      padding: 20px 16px 16px 40px !important;
      
    }

    .nav-header-title-label
    {
      font-weight: 600 !important;
    }
  }  
  
  @media (max-width: 790px) {
    div#content-wrap {
      margin-left: 50px;
    }
  }
</style>




// WEBPACK FOOTER //
// MasterOrange.vue?6e6015b2